import React, {useState, useEffect} from 'react';
import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';

import LogoutIcon from '@mui/icons-material/Logout';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CloseIcon from '@mui/icons-material/Close';
import CreditCardIcon from '@mui/icons-material/CreditCard';

import {SnackBar, DialogWindow} from  './general';
import {getMultipleProducts} from '../services/products.js'
import { getCreditDetailsByUser } from '../services/credit.js'
import dayjs from "dayjs"

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const styleObj = {
    checkProd: {
      marginLeft: 15
    },
    delDialogLeft: {
      minWidth: '60%',
      width:'100%',
    },
    delDialogCont: {
      display: 'flex'
    },
    delDialogRight: {
      width: '40%'
    },
    textarea: {
      width: '100%'
    },
    indNoteCont: {
      marginBottom: '5px'
    },
    noteTitle:{
      fontWeight: 'bold',
      fontSize: '14px',
      textDecoration: 'underline'
    },
    note: {
      fontSize: '14px'
    },
    adv: {
      marginBottom: '10px',
      color: 'green'
    },
    dis: {
      marginBottom: '10px',
      color: '#e1ad01'
    },
    amt: {
      marginBottom: '10px',
      color: '#a0522d'
    },
    bal: {
      marginBottom: '10px',
      color: 'red'
    }
  };

  const AllNotes = ({bookDetails}) => {
    if (bookDetails && bookDetails?.notes) {
      return(
        <Stack sx={{width: '50%'}}>
          <Typography sx={{fontWeight: 'bold', fontSize: 20, textDecoration: 'underline', mb:1}}>Notes</Typography>
        {bookDetails?.notes?.bookingNotes && (
          <Stack>
            <Typography sx={{fontWeight:'bold'}}>Booking Notes</Typography>
            <Typography>{bookDetails?.notes?.bookingNotes}</Typography>
          </Stack>
        )}
        {bookDetails?.notes?.checkoutNotes && (
          <Stack>
            <Typography sx={{fontWeight:'bold'}}>Checkout Notes</Typography>
            <Typography>{bookDetails?.notes?.checkoutNotes}</Typography>
          </Stack>
        )}
        {bookDetails?.notes?.checkinNotes && (
          <Stack>
            <Typography sx={{fontWeight:'bold'}}>Checkin Notes</Typography>
            <Typography>{bookDetails?.notes?.checkinNotes}</Typography>
          </Stack>
        )}
        </Stack>
      )
    }
    return null
  }

  const Cashdetails = ({bookDetails}) => {    
    return (
      <Stack direction="row">
        <AllNotes bookDetails={bookDetails}/>
        <Stack direction="column" sx={{width: '50%'}}>
          <div style={styleObj.amt}>Amount : ₹{bookDetails.amount}/-</div>
          <div style={styleObj.dis}>Discount : ₹{bookDetails.discount}/-</div>
          <div style={styleObj.adv}>Advance : ₹{bookDetails.advance}/-</div>
          <div style={styleObj.bal}>Balance : ₹{bookDetails.amount - bookDetails.advance}/-</div>
        </Stack>
      </Stack>
    )
  }

  const Creditdetails = ({bookDetails, creditDetails}) => {    
    let total = 0;
    return (
      <Stack direction="row" justifyContent="space-between">
        <Stack>

        </Stack>
        <Stack>
          <Typography>Amount : ₹{bookDetails.amount}/-</Typography>
          <Typography>Discount : ₹{bookDetails.discount}/-</Typography>
          <Typography>Advance : ₹{bookDetails.advance}/-</Typography>
          <Typography>Balance : ₹{bookDetails.amount - bookDetails.advance}/-</Typography>
        </Stack>
        <Stack direction="column">
          <Typography sx={{ mb:1, pb:1, fontWeight: "bold"}}>Pending Credits</Typography>
          {creditDetails.map(cred => 
          {
            total += cred.remainingAmount
            return (<Stack direction="row" key={cred._id}><Typography sx={{mr:4}}>{dayjs(cred.createdAt).format("D MMM YYYY")}</Typography><Typography>₹ {cred.remainingAmount}</Typography></Stack>)
          })
          }
          <Typography sx={{textAlign: "right", borderTop: "double black", mt:1, pt: 1 }}>Total : ₹ {total}</Typography>

        </Stack>
      </Stack>
    )
  }

  const Notes = ({currentNote, setCurrentNote, bookDetails}) => {
    const getTitle = (note) => {
      const map = {
        bookingNotes: 'Booking Notes',
        checkoutNotes: 'Checkout Notes',
        checkinNotes: 'Checkin Notes'
      }
      return map[note];
    }
    const getNextTitle = (status) => {
      switch(status) {
        case 'booked':
          return 'Checkout Notes'
        case 'checkedout':
          return 'Checkin Notes'
      }

    }
    const oldNotes = Object.keys(bookDetails.notes || {}).map(note=> {
      if (bookDetails.notes[note]) {
        return (
          <div style={styleObj.indNoteCont}>
            <div style={styleObj.noteTitle}>{getTitle(note)}</div>
            <div style={styleObj.note}>{bookDetails.notes[note]}</div>
          </div>
        )
      }
      return null;
    })
    
    return (
      <>
            {oldNotes}
        {(bookDetails.status === 'booked'  || bookDetails.status === 'checkedout') && (<><Typography variant="subtitle2" component="div">{getNextTitle(bookDetails.status)}</Typography>
          <TextField
            multiline
            aria-label="empty textarea"
            minRows={3}
            key='txt-area'
            value={currentNote}
            onChange={(e)=>{setCurrentNote(e.target.value)}}
            placeholder={getNextTitle(bookDetails.status)}
            sx={styleObj.textarea}
          /></>)}
      </>

    )
  }

     const CompleteProdCheck = ({product, handleLabelClick, checkWarn, setCheckWarn, checkError, setCheckError, checks, status, bookDetail, checkinWarn, pendingChecks}) => {
          return (
               <div>
                    <Stack direction="row" alignItems="center">
                         <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom component="div">{product.name}</Typography>
                         <Typography sx={{ ml: 2 }} variant="body" gutterBottom component="div">({bookDetail.map(item => item.sku).join(',')})</Typography>
                    </Stack>
                    <CompleteCheckBoxes product={product} handleLabelClick={handleLabelClick} status={status} checks={checks} itemCount={bookDetail.length} pendingChecks={pendingChecks}/>
                    <SnackBar message={status === 'booked' ? 'You must select at least one item' : 'You must complete the check list'} open={checkError} handleClose={()=>{setCheckError(false)}} severity={"error"}/>
                    <SnackBar message={'CheckList is not complete. If you want to checkout with partial list, click checkout again'} open={checkWarn} severity={"warning"}/>
                    <SnackBar message={'CheckList is not complete. If you want to proceed with Partial Check-In Please press confirm'} open={checkinWarn} severity={"warning"}/>
               </div>
          )
     }
     
  const CompleteCheckin = ({productDetails, moveToComplete, bookDetails, checkinWarn, checkWarn, setCheckWarn, checkError, setCheckError, handleLabelClick, checks}) => {
     if (Array.isArray(productDetails) && productDetails.length > 0) {
          return productDetails.map(product=><CompleteProdCheck
                    key={`check-${product._id}`}
                    checks={checks}
                    product={product}
                    handleLabelClick={handleLabelClick}
                    checkError={checkError}
                    setCheckError={setCheckError}
                    checkWarn={checkWarn}
                    setCheckWarn={setCheckWarn}
                    status={bookDetails.status}
                    checkinWarn={checkinWarn}
                    pendingChecks={bookDetails.pendingChecks}
                    bookDetail={bookDetails.items.filter(item => item.product === product._id)}
               />)
          }
          return null;
  }
     const CompleteCheckBoxes = ({product, checks, handleLabelClick, itemCount, pendingChecks}) => {
          if (pendingChecks) {
            let checkedItems = []
            for (const checkItem in checks) {
                const [productId, ...rest] = checkItem.split("_")
                const itemName = rest.join(" ")
                const productIncludes = product.includes.find(incl=> incl.item === itemName)
                if (productId === product._id && productIncludes) {
                      checkedItems.push({item: itemName, count: productIncludes.count})
                }
            }
            return (
                <FormGroup sx={styleObj.checkProd}>
                      {
                          checkedItems.map(incl=> {
                                return (<FormControlLabel
                                          disabled={!pendingChecks?.hasOwnProperty(`${product._id}_${incl?.item?.replace(/ /g, '_')}`)}
                                          control={<Checkbox onChange={handleLabelClick(incl?.item, product._id)}
                                          checked={checks[`${product._id}_${incl?.item?.replace(/ /g, '_')}`] || !pendingChecks?.hasOwnProperty(`${product._id}_${incl?.item?.replace(/ /g, '_')}`)}/>}
                                          label={`${(incl?.count)*itemCount} x ${incl?.item} `}
                                />)
                          })
                      
                      }
                </FormGroup>
            )
          } else {
            return null
          }
     }

  const Actions = ({setChecks, bookDetails, checkWarn, setCheckWarn, checkError, setCheckError, checks, setOpen, doCheckIn, doCheckout, doClose, doMoveToCredit, setCurrentNote, moveToCredit, setMoveToCredit, checkinWarn, setCheckinWarn, setCheckinError, moveToComplete, doCompleteCheckIn}) => {

    const handleAction = (status) => {
      const validateCheckoutCheckBox = () => {
          return Object.values(checks).filter(check=> check===true)

      }
        const validateCheckinCheckBox = () => {
            let pendingChecks = {}
            let doneChecks = {}
            for (const obj in checks) {
                if (!checks[obj]) {
                    pendingChecks[obj] = false
                    //setCheckError(true)
                    //return false
                } else {
                  doneChecks[obj] = true
                }
            }
            return {pendingChecks: pendingChecks, doneChecks: doneChecks}
        }
        
      return () => {
          if (status === 'booked') {
              const checkedBoxes = validateCheckoutCheckBox();
              const isAllChecked = checkedBoxes.length === Object.values(checks).length;
              const isAnyChecked = checkedBoxes.length > 0
              if (!isAnyChecked) {
                  setCheckError(true)
                  return
              }
              if (isAllChecked || checkWarn) {
                  doCheckout(checks);
                  setChecks(checks)
                  setCheckWarn(false)
              } else {
                  setChecks(checks)
                  setCheckWarn(true)
              }
          }
          if (status === 'checkedout') {
              const {pendingChecks, doneChecks} = validateCheckinCheckBox()
              
              if (Object.keys(doneChecks).length < 1) {
                    setCheckinError(true)
                    return false                   
              } else {
                setCheckinError(false)
              }
              // Check if there are pending checks
              if (Object.keys(pendingChecks).length > 0) {
                
                if (checkinWarn) { // okay if already warned
                    setCheckinWarn(false)
                    doCheckIn(pendingChecks);
                } else {
                    //else warn first
                    setCheckinWarn(true)
                }
              } else { //No pending checks
                doCheckIn(pendingChecks);
              }
          }
          if (status === 'checkedin') {
            if (moveToCredit){
              doMoveToCredit()
            } else if (moveToComplete) {
              doCompleteCheckIn(checks)
            }
            else {
              doClose();
            }
          }
          if (status === 'closed') {
              doCompleteCheckIn(checks)
          }
      }
    }
      if (bookDetails.status==='booked') {
          return([
              <Button key="back" variant="outlined" onClick={()=>{setChecks({});setOpen(false); setCurrentNote('')}}startIcon={<ArrowBackIosNewIcon />}>Back </Button>,
              <Button key="checkout" variant="contained" onClick={handleAction(bookDetails.status)} endIcon={<LogoutIcon/>}>Checkout </Button>
          ])
      } else if (bookDetails.status==='checkedout') {
          return([
              <Button key="back" variant="outlined" onClick={()=>{setChecks({});setOpen(false); setCurrentNote('')}}startIcon={<ArrowBackIosNewIcon />}>Back </Button>,
              <Button key="checkin" variant="contained" onClick={handleAction(bookDetails.status)} endIcon={<LogoutIcon/>}>{checkinWarn ? 'Confirm' : 'CheckIn'} </Button>
          ])
      }
      else if (bookDetails.status==='checkedin') {
        if (moveToCredit) {
          return([
            <Button key="back" variant="outlined" onClick={()=>{setOpen(false); setCurrentNote(''); setMoveToCredit(false)}}startIcon={<ArrowBackIosNewIcon />}>Back </Button>,
            <Button key="credit" variant="contained" onClick={handleAction(bookDetails.status)} endIcon={<CreditCardIcon/>}>Add To Credit </Button>
          ])
        }
        if (moveToComplete) {
               return([
              <Button key="back" variant="outlined" onClick={()=>{setOpen(false);}}startIcon={<ArrowBackIosNewIcon />}>Back </Button>,
              <Button key="close" disabled={Object.values(checks).indexOf(true) < 0} variant="contained" onClick={handleAction(bookDetails.status)} endIcon={<CloseIcon/>}>Complete </Button>
          ])
        }
          return([
              <Button key="back" variant="outlined" onClick={()=>{setOpen(false); setCurrentNote('')}}startIcon={<ArrowBackIosNewIcon />}>Back </Button>,
              <Button key="close" variant="contained" onClick={handleAction(bookDetails.status)} endIcon={<CloseIcon/>}>Close </Button>
          ])
      }
      else if (bookDetails.status==='closed') {
          return([
              <Button key="back" variant="outlined" onClick={()=>{setOpen(false);}}startIcon={<ArrowBackIosNewIcon />}>Back </Button>,
              <Button key="close" variant="contained" disabled={Object.values(checks).indexOf(true) < 0} onClick={handleAction(bookDetails.status)} endIcon={<CloseIcon/>}>Complete </Button>
          ])
      }
  }

  const ChcekedInBody = ({moveToCredit, moveToComplete, bookDetails, creditDetails, productDetails, checkinWarn, checkWarn, setCheckWarn, checkError, setCheckError, handleLabelClick, checks}) => {
    if (moveToCredit) {
        return <Creditdetails bookDetails={bookDetails} creditDetails={creditDetails}/>
    }
    if (moveToComplete) {
        return <CompleteCheckin
               productDetails={productDetails}
               bookDetails={bookDetails}
               checkinWarn={checkinWarn}
               checkWarn={checkWarn}
               setCheckWarn={setCheckWarn}
               checkError={checkError}
               setCheckError={setCheckError}
               handleLabelClick={handleLabelClick}
               checks={checks}
        />
    }
    return (<Cashdetails bookDetails={bookDetails}/>)
  }

  const ChcekedOutBody = ({productDetails, moveToComplete, bookDetails, checkinWarn, checkWarn, setCheckWarn, checkError, setCheckError, handleLabelClick, checks, checkinError}) => {    
    return productDetails.map(product=><IndProdCheck
                                            key={`check-${product._id}`}
                                            checks={checks}
                                            product={product}
                                            handleLabelClick={handleLabelClick}
                                            checkError={checkError}
                                            setCheckError={setCheckError}
                                            checkWarn={checkWarn}
                                            setCheckWarn={setCheckWarn}
                                            status={bookDetails.status}
                                            checkinWarn={checkinWarn}
                                            checkinError={checkinError}
                                            bookDetail={bookDetails.items.filter(item => item.product === product._id)}
                                        />)
  }

  const Body = ({currentNote, setCurrentNote, advance, setAdvance, productDetails, bookDetails, handleLabelClick, checkError, setCheckError, checkWarn, setCheckWarn, checks, moveToCredit, creditDetails, checkinWarn, checkinError, moveToComplete}) => {  
    console.log(bookDetails.status)
    return (
      <div style={styleObj.delDialogCont}>
        <div style={styleObj.delDialogLeft}>
          {bookDetails.status === 'checkedin' && <ChcekedInBody
                                                    moveToCredit={moveToCredit}
                                                    moveToComplete={moveToComplete}
                                                    bookDetails={bookDetails}
                                                    creditDetails={creditDetails}
                                                    productDetails={productDetails}
                                                    checkinWarn={checkinWarn}
                                                    checkWarn={checkWarn}
                                                    setCheckWarn={setCheckWarn}
                                                    checkError={checkError}
                                                    setCheckError={setCheckError}
                                                    handleLabelClick={handleLabelClick}
                                                    checks={checks}
                                                />}
          {(bookDetails.status === 'booked' || bookDetails.status === 'checkedout') && <ChcekedOutBody
                                                    moveToComplete={moveToComplete}
                                                    productDetails={productDetails}
                                                    bookDetails={bookDetails}
                                                    checkinWarn={checkinWarn}
                                                    checkWarn={checkWarn}
                                                    setCheckWarn={setCheckWarn}
                                                    checkError={checkError}
                                                    setCheckError={setCheckError}
                                                    handleLabelClick={handleLabelClick}
                                                    checks={checks}
                                                    checkinError={checkinError}
                                                />}
          {bookDetails.status === 'closed' && <CompleteCheckin
                                                  productDetails={productDetails}
                                                  bookDetails={bookDetails}
                                                  checkinWarn={checkinWarn}
                                                  checkWarn={checkWarn}
                                                  setCheckWarn={setCheckWarn}
                                                  checkError={checkError}
                                                  setCheckError={setCheckError}
                                                  handleLabelClick={handleLabelClick}
                                                  checks={checks}
                                             />}
        </div>
        
        {(bookDetails.status === 'booked' || bookDetails.status === 'checkedout') && (<div style={styleObj.delDialogRight}>
        {(bookDetails.advance === 0 && bookDetails.status === 'booked') && <div style={{marginBottom:'10px'}}> <TextField  value={advance} onChange={(e)=>{setAdvance(e.target.value)}} label="Advance (₹)" /></div>}
        <Notes currentNote={currentNote} setCurrentNote={setCurrentNote} bookDetails={bookDetails}/>
        </div>)}
      </div>
    )
  }

  const IndProdCheck = ({product, handleLabelClick, checkWarn, setCheckWarn, checkError, setCheckError, checks, status, bookDetail, checkinWarn, checkinError}) => {
    return (
      <div>
        <Stack direction="row" alignItems="center">
          <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom component="div">{product.name}</Typography>
          <Typography sx={{ ml: 2 }} variant="body" gutterBottom component="div">({bookDetail.map(item => item.sku).join(',')})</Typography>
        </Stack>
        <CheckBoxes product={product} handleLabelClick={handleLabelClick} status={status} checks={checks} itemCount={bookDetail.length}/>
        <SnackBar message={status === 'booked' ? 'You must select at least one item' : 'You must complete the check list'} open={checkError} handleClose={()=>{setCheckError(false)}} severity={"error"}/>
        <SnackBar message={'CheckList is not complete. If you want to checkout with partial list, click checkout again'} open={checkWarn} severity={"warning"}/>
        <SnackBar message={'CheckList is not complete. If you want to proceed with Partial Check-In Please press confirm'} open={checkinWarn} severity={"warning"}/>
        <SnackBar message={'You need to check at least one item'} open={checkinError} severity={"error"}/>
      </div>
    )
  }

  const CheckBoxes = ({status, product, checks, handleLabelClick, itemCount}) => {
    if (status === "checkedout") {
        let checkedItems = []
        for (const checkItem in checks) {
          const [productId, ...rest] = checkItem.split("_")
          const itemName = rest.join(" ")
          const productIncludes = product.includes.find(incl=> incl.item === itemName)
          if (productId === product._id && productIncludes) {
            checkedItems.push({item: itemName, count: productIncludes.count})
          }
        }
        /*const checkedItems = Object.keys(checks).map(key => {
            const items = key.split("_");
            items.splice(0,1)
            return items.join(" ")
        }).map(item => {
            console.log(item)
            return product.includes.find(incl => {
              return incl.item === item
            })
        }).filter(item => item !== undefined)*/



        /*console.log(checks)
        console.log("---")
        console.log(product)*/
        return (
            <FormGroup sx={styleObj.checkProd}>
                {checkedItems.map(incl=> (<FormControlLabel control={<Checkbox onChange={handleLabelClick(incl?.item, product._id)} checked={checks[incl?.item?.replace(/ /g, '_')]}/>} label={`${(incl?.count)*itemCount} x ${incl?.item} `} />))}
            </FormGroup>
        )
    }
    if (status === "booked") {
        return (
            <FormGroup sx={styleObj.checkProd}>
                {product.includes.map(incl=> (<FormControlLabel control={<Checkbox onChange={handleLabelClick(incl?.item, product._id)} checked={checks[incl?.item?.replace(/ /g, '_')]}/>} label={`${(incl?.count)*itemCount} x ${incl?.item} `} />))}
            </FormGroup>
        )
    }
  }
const CheckoutDialog = ({open, advance, setAdvance, bookings, setOpen, doCheckout, doCheckIn, doClose, doMoveToCredit, selectedBooking, currentNote, setCurrentNote, setSelectedBooking, moveToCredit, setMoveToCredit, moveToComplete, doCompleteCheckIn}) => {
    const [productDetails, setProductDetails] = useState([])
    const [bookDetails, setBookDetails] = useState({});
    const [creditDetails, setCreditDetails] = useState([])
    const [checks, setChecks] = useState({})
    const [checkWarn, setCheckWarn] = useState(false);
    const [checkError, setCheckError] = useState(false);
    const [dialogTitle, setDialogTitle] = useState('');
    const [checkinWarn, setCheckinWarn] = useState(false)
    const [checkinError, setCheckinError] = useState(false)

    useEffect(()=>{
      const getData = async () => {
        const book = bookings.find(book=>book._id === selectedBooking)
        setBookDetails(book)
        const ids = book.products.map(x=>x.id)
        const data = await getMultipleProducts(ids);
        setProductDetails(data)

        if (book.status === 'booked') {
            const items = data.flatMap(x=>x.includes.map(inc=>x._id + '_' + inc.item.replace(/ /g, '_')))
            let _checks = {};
            items.forEach(item=> {
              _checks[item] = false
            })
            setChecks(_checks)
            setDialogTitle('Check Out')
        }
        if (book.status === 'checkedout') {
            const savedChecks= Object.fromEntries(
                Object.entries(book.checks ?? checks)
                .filter(([key, value]) => value === true)
                .map(([key, value]) =>  [key, false]) 
            );
            setChecks(savedChecks)
            setDialogTitle('Check In')
        }
        if (book.status === 'checkedin') {
          if (moveToComplete) {
               const savedChecks= Object.fromEntries(
                     Object.entries(book.checks ?? checks)
                    .filter(([key, value]) => value === true)
                    .map(([key, value]) =>  [key, !value]) 
               );
               setChecks(savedChecks)
               console.log(book.checks)
               setDialogTitle('Complete Check In')
          }
          else if (moveToCredit) {
            const credits = await getCreditDetailsByUser(book.tenant._id);
            setCreditDetails(credits)                                                                                
          } else {
            setDialogTitle('Close')
          }
        }
        if (book.status === 'closed') { 
           if (moveToComplete) {
               const savedChecks= Object.fromEntries(
                     Object.entries(book.checks ?? checks)
                    .filter(([key, value]) => value === true)
                    .map(([key, value]) =>  [key, !value]) 
               );
               setChecks(savedChecks)
               console.log(book.checks)
               setDialogTitle('Complete Check In')
          }
        }
        
      }
      if (open) {
        getData()
      }
        return () => {
            setCheckWarn(false)
            setCheckinWarn(false)
            setCheckError(false)
            setChecks([])
        }
    }, [open, selectedBooking])

     const handleLabelClick = (item, id) => {
          if (item) {
               return (event) => {                    
                    let _checks  = {...checks};
                    _checks[id + '_' + item.replace(/ /g, '_')] = event.target.checked
                    setChecks(_checks)
               };
          }
     }


    /*return (
      <DialogWindow title={dialogTitle} Body={Body} currentNote={currentNote} setCurrentNote={setCurrentNote} Actions={Actions} open={open} setOpen={setOpen}  maxWidth={'sm'}/>
    )*/
    return (
      <Dialog
        onClose={()=>{setOpen(false)}}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={'sm'}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={()=>{setOpen(false)}}>
          {dialogTitle}
        </BootstrapDialogTitle>
        <DialogContent dividers>
         <Body
          checkWarn={checkWarn}
          setCheckWarn={setCheckWarn}
          currentNote={currentNote}
          advance={advance}
          setAdvance={setAdvance}
          setCurrentNote={setCurrentNote}
          productDetails={productDetails}
          bookDetails={bookDetails}
          handleLabelClick={handleLabelClick}
          checkError={checkError}
          setCheckError={setCheckError}
          checks={checks}
          moveToCredit={moveToCredit}
          moveToComplete={moveToComplete}
          creditDetails={creditDetails}
          checkinWarn={checkinWarn}
          checkinError={checkinError}
        />

        </DialogContent>
        <DialogActions>
          <Actions
            setCheckWarn={setCheckWarn}
            checkWarn={checkWarn}
            setChecks={setChecks}
            setSelectedBooking={setSelectedBooking}
            setCurrentNote={setCurrentNote}
            bookDetails={bookDetails}
            checkError={checkError}
            setCheckError={setCheckError}
            checks={checks}
            setOpen={setOpen}
            doCheckout={doCheckout}
            doCheckIn={doCheckIn}
            doClose={doClose}
            moveToCredit={moveToCredit}
            moveToComplete={moveToComplete}
            doMoveToCredit={doMoveToCredit}
            setMoveToCredit={setMoveToCredit}
            checkinWarn={checkinWarn}
            setCheckinWarn={setCheckinWarn}
            setCheckinError={setCheckinError}
            doCompleteCheckIn={doCompleteCheckIn}
          />
        </DialogActions>
      </Dialog>
    )
  }


  export default CheckoutDialog
